<div id="carrier-change">
    <div class="full-width-image-section privacy-top">
        <div class="arrow-up-grey">
            <next-topbar></next-topbar>
            <next-menu></next-menu>

            <div class="container white">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <h1 class="header-title">Information om risikobærerskift</h1>
                        <p class="header-text">Her kan du finde information og få svar på dine spørgsmål om risikobærerskiftet.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="tabs-container">
        <div class="container">
            <div class="row text-center">
                <div class="col-xs-12 col-sm-4">
                    <div class="tab-header active" [ngClass]="{ active: activeTab === 'questions' }" (click)="setTab('questions')">
                        <i class="nf nf-questions-icon-v3"></i>
                        <br />
                        <span>Spørgsmål og svar</span>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="tab-header" [ngClass]="{ active: activeTab === 'info' }" (click)="setTab('info')">
                        <i class="nf nf-betingelser-almindelige"></i>
                        <br />
                        <span>Info om risikobærerskift</span>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4">
                    <div class="tab-header" [ngClass]="{ active: activeTab === 'privacy' }" (click)="setTab('privacy')">
                        <i class="nf nf-security-icon"></i>
                        <br />
                        <span>Privatlivspolitik</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="overview-container">
        <div *ngIf="activeTab === 'questions'">
            <div class="container content">
                <div class="row">
                    <div class="col-xs-12">
                        <h1>Spørgsmål og svar</h1>

                        <h5>Hvad er en risikobærer?</h5>
                        <p>En risikobærer er det forsikringsselskab, der har forpligtelsen til at betale i tilfælde af, at der sker skade på dine forsikringer.</p>

                        <h5>Hvem er Eir Forsäkring?</h5>
                        <p>
                            Eir Försäkring står for innovation og digitalisering, hvor de sammen med deres partnere udfordrer de etablerede aktører på forsikringsmarkedet ved at være
                            digitale, transparente og effektive. Målet er at skabe et nyt og digitaliseret forsikringsmarked.
                        </p>
                        <p>
                            Eir Försäkring har tilladelse fra det svenske finanstilsyn til at udføre forsikringsvirksomhed i henhold til svensk lov. De er aktive i Sverige, Danmark, Norge og
                            Finland og har licens til at udføre forsikringsaktiviteter i Tyskland. I Danmark står de bag flere andre danske forsikringsformidlere.
                        </p>

                        <h5>Hvad betyder skiftet for mig?</h5>
                        <p>
                            Rent praktisk betyder skiftet intet for dig som kunde. Dine forsikringsdækninger, forsikringsbetingelser, vilkår og priser er præcis de samme, som de altid har
                            været. Rent teknisk er det eneste, der ændrer sig er at Eir Försäkring har adgang til dine oplysninger, hvor det før var Gjensidige Forsikring, og det vil være
                            Eir Försäkring AB, som vil stå for den økonomiske risiko, hvor det tidligere var Gjensidige Forsikring.
                        </p>

                        <h5>Hvorfor samarbejder I ikke med Gjensidige længere?</h5>
                        <p>
                            De sidste mange år har NEXT formidlet forsikringer til forbrugere med NEM Forsikring som risikobærer. Grundet fusion mellem NEM Forsikring og Gjensidige
                            Forsikring ophører samarbejdet mellem NEXT og NEM Forsikring. Vi har i stedet valgt at samarbejde med Eir Försäkring, der ligesom NEXT har et mål om at skabe et
                            nyt og digitaliseret forsikringsmarked.
                        </p>

                        <h5>Er der ændringer til mine forsikringer?</h5>
                        <p>
                            Nej, du kan være helt rolig. Dine forsikringsdækninger, forsikringsbetingelser, vilkår og priser er præcis de samme, som de altid har været. Hvis der er ændringer
                            til dine forsikringer, vil du blive varslet herom i overensstemmelse med dine forsikringsbetingelser.
                        </p>

                        <h5>Skal jeg gøre noget i forhold til min betalingsaftale?</h5>
                        <p>Nej, din betalingsaftale fortsætter automatisk, uanset om du har valgt MobilePay, kreditkort eller benytter BetalingsService.</p>

                        <h5>Hvad hvis jeg ikke ønsker at skifte risikobærer?</h5>
                        <p>
                            Hvis du ikke ønsker, at din forsikring skal overdrages fra Gjensidige Forsikring ASA til Eir Försäkring AB, har du ret til at opsige din forsikringsaftale i
                            overensstemmelse med dine forsikringsbetingelser.
                        </p>

                        <h5>Har du spørgsmål?</h5>
                        <p>
                            Hvis du har spørgsmål til skiftet af risikobærer som du ikke har fundet svar på, så er du meget velkommen til at skrive til mail@next.dk eller give os et kald på
                            tlf. 70407040.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="activeTab === 'info'">
            <div class="container content">
                <div class="row">
                    <div class="col-xs-12">
                        <h1>Information om risikobærerskift</h1>

                        <p>
                            Lige nu samarbejder vi med det norske selskab Gjensidige Forsikring ASA som risikobærer. Vi har valgt at starte et samarbejde med det svenske selskab Eir
                            Försäkring, der fremadrettet vil være vores risikobærer.
                        </p>

                        <h5>Hvad er en risikobærer?</h5>
                        <p>
                            Indenfor forsikringsverdenen er en risikobærer det forsikringsselskab, som i sidste ende er forpligtiget til at betale erstatning til dig, hvis du har haft en
                            skade.
                        </p>

                        <h5>Hvem er Eir Försäkring?</h5>
                        <p>
                            De er et svensk forsikringsselskab, der har solid erfaring inden for forsikringsverdenen som fundament for efterhånden mange forsikringsbrands i både Danmark,
                            Sverige, Norge og Finland. Eir er selvfølgelig medlem af Garantifonden i Danmark, så du kan stadig være helt tryg.
                        </p>

                        <p>Vores samarbejde med Eir starter den 01.11.2023.</p>

                        <div class="eir-logo-container">
                            <img class="eir-logo" src="https://static.next.dk/website/images/pages/eir/eir-logo.png" />
                        </div>

                        <h5>For de nysgerrige</h5>
                        <p>
                            Vi har i samarbejde med Eir Försäkring AB og Gjensidige Forsikring ASA ansøgt om at få overdraget rollen som risikobærer for NEXT fra Gjensidige Forsikring ASA
                            til Eir Försäkring AB.
                        </p>
                        <p>
                            Risikobærerskiftet fra Gjensidige Forsikring ASA til Eir Försäkring AB blev godkendt den 18. august 2023 af det norske Finanstilsyn. Både det danske Finanstilsyn
                            samt det svenske Finanstilsyn har indstillet deres godkendelser til overdragelsen til det norske Finanstilsyn. I finder den danske publicering af godkendelsen
                            <a href="https://www.statstidende.dk/messages/S15092023-256" target="_blank">her.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="activeTab === 'privacy'">
            <div class="container content">
                <div class="row">
                    <div class="col-xs-12">
                        <h1>Privatlivspolitik ifbm. risikobærerskifte</h1>

                        <p>
                            Når du er kunde hos NEXT Forsikring A/S – Forsikringsformidling, er det NEM Forsikring, dansk filial af Gjensidige Forsikring ASA, Norge (herefter omtalt
                            Gjensidige), som er dataansvarlig for de oplysninger, vi har modtaget og behandler om dig.
                        </p>
                        <p>
                            Gjensidige samarbejder med nogle forsikringsdistributører, herunder NEXT Forsikring, som indtegner kunder til Gjensidige både i Gjensidiges navn, men også i eget
                            navn. Gjensidige er i alle henseende risikobærer på disse forsikringsaftaler. Gjensidiges rolle som dataansvarlig følger derfor af det samarbejde, som vi har med
                            Gjensidige om denne forsikringsdistribution, mens vi er databehandler for Gjensidige.
                        </p>
                        <p>
                            Vi har imidlertid fundet en ny samarbejdspartner, og det betyder, at vi fra den 1/11-2023 får det svenske selskab EIR Försäkring som risikobærer. Som følge heraf
                            er EIR Försäkring dataansvarlig og NEXT Forsikring databehandler for så vidt angår de personoplysninger, der anvendes til at levere forsikringsydelser til dig. I
                            midlertidig vil NEXT Forsikring være dataansvarlig for så vidt angår de personoplysninger, vi behandler for at kunne prissætte vores forsikringer og foretage
                            analyser af vores statistikker.
                        </p>
                        <p>Til og med 31/10-2023 er den dataansvarlige derfor Gjensidige.</p>

                        Gjensidige Forsikring, Dansk Filial af Gjensidige Forsikring A/S, Norge
                        <br />
                        A.C. Meyers Vænge 9
                        <br />
                        2450 København SV
                        <br />
                        CVR-nr.: 33 25 92 47
                        <br />
                        Tlf. 88 18 67 36
                        <br />
                        <br />

                        <p>Fra den 1/11-2023 vil den dataansvarlige være hhv. EIR Försäkring og NEXT Forsikring fordelt som beskrevet ovenfor.</p>

                        EIR Försäkring AB
                        <br />
                        Box 3132, SE – 103 56 Stockholm
                        <br />
                        Reg. No.: 559166-0617
                        <br />
                        E-mail: info@eirforsakring.se
                        <br />

                        NEXT Forsikring A/S –Forsikringsformidling
                        <br />
                        Danmarksvej 26
                        <br />
                        8660 Skanderborg
                        <br />
                        CVR-nr.: 34 70 69 05
                        <br />
                        Tlf. 70 40 70 40
                        <br />
                        E-mail: persondata@next.dk
                        <br />

                        <h5>Dine personoplysninger i forbindelse med risikobærerskifte</h5>
                        <p>
                            Når vi behandler dine personoplysninger i forbindelse med risikobærerskiftet, vil behandlingen være identisk med den behandling, som i forvejen finder sted som
                            led i dit kundeforhold. Du kan læse nærmere herom i vores almindelige <a href="https://next.dk/persondata-og-cookiepolitik" target="_blank">persondatapolitik</a>,
                            som du har accepteret, da du blev kunde hos os.
                        </p>

                        <p>
                            Kort sagt, så vil vi fortsætte med at behandle dine personoplysninger med samme formål, som hidtil; det vil sige for at kunne administrere dine
                            forsikringsprodukter, herunder behandle eventuelle skadessager og andre tilknyttede ydelser, såsom rådgivning, nyhedsbreve og markedsføringsmateriale.
                            Personoplysningerne bruges altså blandt andet til opkrævning af præmier, udbetaling af erstatning, men også til undersøgelser og analyser for at forbedre vores
                            produkter, tjenester og teknologier, m.v.
                        </p>

                        <p>
                            Ligeledes vil vi behandle personoplysninger om personer, som er medforsikret på en police, begunstiget, modpart i en skadessag som du som kunde er impliceret i –
                            herunder både skadevolder, skadelidte, vidne, reparatør i en skadessag og lignende.
                        </p>

                        <p>Der er tale om følgende typer af personoplysninger:</p>

                        <ul>
                            <li>
                                <b>Almindelige oplysninger</b> såsom dit navn, adresse, telefonnummer, e-mailadresse, kundenummer, policenummer, skadenummer, betalingsoplysninger og øvrige
                                relevante forsikringsoplysninger som f.eks. BBR-oplysninger, din øvrige skadeshistorik m.v., jf. Databeskyttelsesforordningen art. 6, stk. 1, litra a og b.
                            </li>
                            <li>
                                <b>Følsomme oplysninger</b> såsom dine helbredsoplysninger, hvis du f.eks. har modtaget forsikringsdækket lægebehandling i forbindelse med en skade, eller du
                                har fået udbetalt erstatning for varigt mén eller lignende, jf. Databeskyttelsesforordningen art. 9, stk. 2, litra a og f.
                            </li>
                            <li>
                                <b>Strafbare forhold</b>, hvis du f.eks. har været involveret været involveret i en trafikulykke, hvor din ansvarsforsikring har dækket skader som følge af
                                færdselsforseelser eller lignende, jf. Databeskyttelseslovens § 8, stk. 3.
                            </li>
                            <li><b>CPR-nummer</b>, jf. Databeskyttelseslovens § 11, stk. 2, nr. 4, jf. § 7, stk. 1, smh. Databeskyttelsesforordningen art. 9, stk. 2, litra f.</li>
                        </ul>

                        <p>
                            Personoplysningerne behandles naturligvis kun, hvis dette er nødvendigt for at kunne varetage dine interesser som kunde hos os og den sagsbehandling, der følger
                            af dit kundeforhold eller følger af et eventuelt retskrav, som vi skal forsvare, f.eks. i forbindelse med en skadessituation.
                        </p>

                        <p>
                            En del af disse personoplysninger vil være afgivet af dig selv som kunde, men vi kan også modtage og registrere oplysninger om dig fra andre, hvis du har givet
                            samtykke til det, mens nogle personoplysninger vil være indhentet og registreret fra offentlige registrer som f.eks. det Centrale Personregister, Det Centrale
                            Motorregister og Bygnings- og Boligregistret.
                        </p>

                        <p>
                            Dine følsomme personoplysninger behandler vi naturligvis med særlig varsomhed og kun i det omfang, det er påkrævet for opgavens korrekte udførelse. Dette betyder
                            blandt andet, at systemmæssige begrænsninger gør, at kun medarbejdere med et arbejdsmæssigt behov herfor har adgang til disse personoplysninger.
                        </p>

                        <p>
                            I forbindelse med risikobærerskiftet vil vi behandle dine personoplysninger og herunder videregive dine personoplysninger til EIR Försäkring, så dine forsikringer
                            kan oprettes med samme dækning, præmie og vilkår, som dine nuværende samt eventuelle tredjeparter, som er nødvendige for administrationen og overdragelsen af dine
                            personoplysninger i forbindelse med risikobærerskiftet. Disse personoplysninger stemmer overens med, hvad der er beskrevet ovenfor.
                        </p>

                        <h5>Hvem kan dine personoplysninger videregives til</h5>
                        <p>
                            Vi opbevarer og overfører dine personoplysninger i overensstemmelse med gældende lovgivning. Dette betyder, at dine personoplysninger kun videregives inden for
                            rammerne af Lov om Finansiel Virksomhed, Databeskyttelsesforordningen og Databeskyttelsesloven, medmindre du har givet samtykke til videregivelse i videre omfang.
                        </p>

                        <p>
                            Så snart risikobærerskiftet er gennemført, vil dine personoplysninger kun behandles i overensstemmelse med vores almindelige
                            <a href="https://next.dk/persondata-og-cookiepolitik" target="_blank">persondatapolitik</a>, som du har accepteret, da du blev kunde hos os.
                        </p>

                        <p>
                            Dine personoplysninger vil således kun blive behandlet til kundeadministration og forsikringsrådgivning i forbindelse med risikobærerskiftet og dit fortsatte
                            kundeforhold herefter.
                        </p>

                        <h5>Hvor opbevares dine oplysninger</h5>
                        <p>
                            Nogle af vores samarbejdspartnere og/eller leverandører, der behandler personoplysninger på vores vegne, behandler dine personoplysninger udenfor EU/EØS i et
                            såkaldt tredjeland. I disse tilfælde vil vi, for at beskytte dine personoplysninger, sikre os, at tredjelandet, hvori data opbevares, overholder et af EU
                            anerkendt og tilstrækkeligt databeskyttelsesniveau.
                        </p>
                        <p>
                            Såfremt tredjelandet ikke overholder et anerkendt og tilstrækkeligt databeskyttelsesniveau, vil vi kun tillade overførsel af personoplysninger til databehandlere,
                            som er underlagt forpligtelser, der svarer til beskyttelsesreglerne i EU – enten i form af standardbestemmelser/modelkontrakter eller certificeringsordning
                            (Privacy Shield), der er godkendt af EU-Kommissionen.
                        </p>

                        <h5>Hvor længe gemmer vi dine oplysninger</h5>
                        <p>
                            Vi og vores samarbejdspartnere og/eller leverandører opbevarer alene dine personoplysninger så længe, der er et sagligt, relevant og nødvendigt formål med
                            opbevaringen/behandlingen heraf. Herefter sletter eller anonymiserer vi dine oplysninger.
                        </p>

                        <p>
                            De personoplysninger, som alene behandles af os eller vores samarbejdspartnere og/eller leverandører, til brug for risikobærerskiftet, vil derfor blive slettet
                            eller anonymiseret, så snart risikobærerskiftet er gennemført, og oplysningerne ikke længere er relevante. Herefter vil de dine personoplysninger kun blive gemt
                            og behandlet, så længe de er nødvendige for dit kundeforhold eller øvrige årsager foranlediger længere opbevaring.
                        </p>

                        <p>
                            Hvor længe, vi sædvanligvis gemmer dine personoplysninger, er beskrevet i vores almindelige
                            <a href="https://next.dk/persondata-og-cookiepolitik" target="_blank">persondatapolitik</a>, som du har accepteret, da du blev kunde hos os.
                        </p>

                        <h5>Dine rettigheder</h5>
                        <p>Du har efter Databeskyttelsesforordningen en række rettigheder i forhold til behandlingen af dine personoplysninger.</p>

                        <ul>
                            <li>
                                Ret til indsigt, berettigelse og supplering:
                                <ul>
                                    <li>Du har ret til at få oplyst/indsigt i, hvilke personoplysninger vi behandler om dig</li>
                                    <li>Hvis der er fejl i de oplysninger, vi behandler om dig, er du berettiget til at få disse urigtige oplysninger rettet.</li>
                                    <li>
                                        Du har ligeledes ret til at få fuldstændiggjort de personoplysninger, som vi behandler om dig, hvis de er væsentlige for vores behandling af dine
                                        personoplysninger.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Ret til sletning
                                <ul>
                                    <li>
                                        Du er berettiget til at få slettet de personoplysninger, vi behandler om dig, når disse ikke længere er nødvendige for at kunne opfylde de formål, som
                                        vi behandler personoplysningerne til, og personoplysningerne ikke længere kan tænkes at skulle anvendes i forbindelse med retskrav.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Ret til begrænsning af vores behandling
                                <ul>
                                    <li>
                                        I den periode, hvor vi vurderer din indsigelse eller dit ønske, er du berettiget til at kræve, at vi begrænser vores behandling af dine oplysninger,
                                        så vi alene opbevarer disse, indtil din henvendelse er behandlet, eller vi anvender disse i forbindelse med retskrav. Det ændrer dog ikke på, at vi
                                        fortsat opkræver præmie, da aftaleforholdet mellem dig og os fortsat består.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Ret til dataportabilitet
                                <ul>
                                    <li>
                                        Du har ret til at modtage en elektronisk kopi af de personoplysninger, som vi har modtaget om dig, hvis vi behandler disse oplysninger elektronisk.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Ret til at tilbagekalde samtykke
                                <ul>
                                    <li>Du kan til enhver tid trække dit samtykke tilbage, hvilket medfører, at det, du har givet samtykke til, vil ophøre, f.eks. markedsføring.</li>
                                    <li>
                                        En tilbagekaldelse af dit samtykke påvirker ikke lovligheden af den behandling af dine personoplysninger, som allerede har fundet sted på baggrund af
                                        dit tidligere samtykke.
                                    </li>
                                    <li>
                                        Vi kan være berettiget til at opbevare og behandle (nogle af) dine personoplysninger fortsat f.eks. for at forsvare et retskrav. En tilbagekaldelse af
                                        et eventuelt afgivet samtykke er altså ikke ensbetydende med, at vi sletter alle oplysninger om dig.
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <p>Hvis du ønsker at gøre brug af dine rettigheder, bedes du kontakte os på ovenstående kontaktoplysninger.</p>

                        <h5>Hvordan kan du klage over vores behandling af dine oplysninger</h5>
                        <p>Hvis du er utilfreds med vores behandling af dine personoplysninger, kan du klage til den danske tilsynsmyndighed:</p>

                        Datatilsynet
                        <br />
                        Borgergade 28, 5.
                        <br />
                        1300 København K
                        <br />
                        E-mail: dt@datatilsynet.dk
                        <br />
                        Telefon: 33 19 32 00
                        <br />
                        <br />

                        <p>Vi foreslår dog, at du altid oplyser os om din eventuelle utilfredshed, inden du retter henvendelse til Datatilsynet.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <next-footer></next-footer>
</div>
